/* eslint-disable*/
import React, { useState } from 'react'
import GetContentsList from '../../Services/Queries/GetContentsList'
import DeleteContent from '../../Services/Mutations/DeleteContent'
import { Link } from 'react-router-dom'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import ArchiveContentFromRedis from '../../Services/Mutations/ArchiveContent'
import AddContentToBoxOffice from '../../Services/Mutations/AddContentToBoxOffice'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import _ from 'lodash'
import {
	heightPercentageToDP,
	widthPercentageToDP,
} from "../../Utils/ResponsiveScreen"

import MDEditor from "@uiw/react-md-editor"
import html2canvas from "html2canvas"
import { fonts } from "../Constants/theme"
import AddPointsToContent from "./AddPointsToContent"
import NewsOnTop from "./NewsOnTop"
import RepostContentAction from "./RepostContentAction"
import AddContentToListAction from "./AddContentToListAction"
import AwsConfig from "../../Config/AwsConfig"
import DeleteContentInSingleLanguage from "../../Services/Mutations/DeleteContentInSingleLanguage"
import CreateTwitterPost from "../../Services/Mutations/CreateTwitterPost"
import SearchContentsService from "../../Services/Queries/SearchContentsService"
import GetUserPermissions from "../../Services/Queries/GetUserPermissions"
import { DefinedPermissions } from "../Constants/Permissions"
import SearchContentsByTypeAndCategory from "../../Services/Queries/SearchContentsByTypeAndCategory"
import SendPushNotification from "./SendContentPushNotification"
import { publishedContentsHeadings } from "../Data/StaticData"
import Header from "../header"
import Spinner from "../header/Spinner"
import DuplicateContentForm from "./DuplicateContentForm"
import ShareToSocialMedia from "../SocialMediaShare/ShareToSocialMedia"
import EditTitle from "./EditTitle"
import EditDesc from "./EditDesc"
const styles = {
	fontSize: {
		fontSize: '12px',
	},
}

class PublishedContentsList extends React.Component {
	toastStyle = {
		position: "top-right",
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	};
	constructor(props) {
		super(props)

		this.state = {
			editedTitle: "",
			isReadMore: true,
			searchQuery: "",
			searched: false,
			from: 0,
			initialFromValue: 0,
			initialLoadMore: true,
			totalSearchResultsCount: 0,
			showArchived: false,
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: "selection",
			},
			archiveModalVisible: false,
			addToBoxOfficeModalVisible: false,
			showDatePicker: false,
			error: false,
			publishedContentsList: [],
			limit: 100,
			nextToken: null,
			render: false,
			endReached: false,
			loadMore: false,
			props: props,
			userDetails: {},
			userPermissions: [],
			reload: false,
			contentSelectedLang: null,
			currentPage: 1,
			headings: publishedContentsHeadings,
			deleteModalVisible: false,
			selectedContentId: "",
			selectedContentLanguages: [],
			capturePostModal: false,
			selectedItem: null,
			displayDescription: "",
			displayContents: [
				"Story",
				"ShortByte",
				"CoverStory",
				"Mcq",
				"Poll",
				"SlideShow",
				"liveCricketScore",
				"cricketPointsTable",
				"liveNews",
			],
			contentsTypes: [
				"Story",
				"ShortByte",
				"CoverStory",
				"Mcq",
				"Poll",
				"SlideShow",
				"liveCricketScore",
				"cricketPointsTable",
				"liveNews",
			],
			tweetPostModal: false,
			enableTweetImages: true,
			enableTwitterShareLink: false,
			tweetImages: [],
			twitterShareLink: ``,
			twitterShareLinkText: `మరిన్ని ఆసక్తికరమైన సంక్షిప్త వార్తలు & వైరల్ వీడియోల కోసం YouSay తెలుగు న్యూస్ యాప్‌ను ఇన్‌స్టాల్ చేయండి.`,
			twitterTitle: "",
			twitterDescription: "",
			tweetTags: "",
			filteredContentTypes: [],
			filteredContentMainCategories: [],
			filteredFirstLevelContentCategories: [],
			filteredSecondLevelContentCategories: [],
			filteredThirdLevelContentCategories: [],
			loggedInUserPermissions: [],
			selectedFilterType: "",
			attachAppPromoteText: false,
			editpopup: false,
			editDescPopup: false,
			editingIndexDesc: "",
			Title: "",
			editedArray: [],
			editingIndex: "",
			changedTitle: "",
			pop: false,
			editedTitle: "",
			publishedContentsListdata: []

		}
		this.defaultTwitterShareLink = "https://s.yousay.tv/Q3BA"
		this.loadMore = this.loadMore.bind(this)
	}

	loadMore = async () => {
		await this.getNextPublishedContentsList()
	};
	toggleShowArchived = () => {
		this.setState({ showArchived: !this.state.showArchived })
	};
	getPublishedContentsList = async () => {
		this.setState({ loading: true })
		const { limit } = this.state
		const input = {
			limit: limit,
			nextToken: null,
			contentStatus: "published",
			appInfoFrontEnd: {
				appVersionNumber: 60,
			},
			language: this.state.appLanguage,
		}
		console.log(input, "input firstt========")
		const publishedContentsList = await GetContentsList(input)
		this.setState({ publishedContentsListdata: publishedContentsList })
		console.log(publishedContentsList, "publishedContentsList=====")
		const permissionInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userPermissions = await GetUserPermissions(permissionInput)
		let permissions = []
		let permissionsArr = []
		if (userPermissions && userPermissions.userRolesAndPermissions) {
			userPermissions.userRolesAndPermissions.map((item, index) => {
				permissions.push(...item.permissions)
			})
			permissions.map((permission) => {
				permissionsArr.push(permission.name)
			})
		}
		const filteredItems = publishedContentsList.items
			.map((item, index) => {
				const { wordPressPostStatus, wordPressPostURL } =
					item?.wordPressInfo || ""
				if (wordPressPostStatus == "publish" && wordPressPostURL) {
					return index
				} else {
					return false
				}
			})
			.filter((item) => item != false)
		console.log(filteredItems, "publishedContentsList=====")

		this.setState({
			loading: false,
			render: true,
			nextToken: publishedContentsList.nextToken,
			publishedContentsList: publishedContentsList.items,
			loggedInUserPermissions: permissionsArr,
		})
	};
	getNextPublishedContentsList = async () => {
		const { limit, filtered } = this.state
		const input = {
			limit: limit,
			nextToken: this.state.nextToken,
			contentStatus: "published",
			appInfoFrontEnd: {
				appVersionNumber: 60,
			},
			language: this.state.appLanguage,
		}
		if (filtered) {
			const { selectionRange, limit } = this.state
			const epochStartTime = selectionRange.startDate.getTime()
			const epochEndTime = selectionRange.endDate.getTime()
			const startTime = Math.trunc(epochStartTime / 1000)
			const endTime = Math.trunc(epochEndTime / 1000)
			input.fromTime = startTime
			input.toTime = endTime
		}
		console.log(input, "inputttttttnextttttttt")
		const data = await GetContentsList(input)
		console.log(data.items, "next dataaaaaaaaaaaaaaaaaaaa")
		if (data.nextToken == null) {
			this.setState({
				publishedContentsList: [
					...this.state.publishedContentsList,
					...data.items,
				],
				nextToken: null,
			})
		} else {
			this.setState({
				publishedContentsList: [
					...this.state.publishedContentsList,
					...data.items,
				],
				nextToken: data.nextToken,
			})
		}
	};
	handleSelectedContentTypes = (item) => {
		if (this.state.displayContents?.includes(item)) {
			const displayContentsData = this.state.displayContents
			const newData = displayContentsData.filter((val) => val != item)
			this.setState({ displayContents: newData })
		} else {
			const displayContentsData = this.state.displayContents
			displayContentsData.push(item)
			this.setState({ displayContents: displayContentsData })
		}
	};
	loadMoreContentsByType = async () => {
		const input = {
			limit: 20,
			nextToken: this.state.nextToken,
		}
		if (
			this.state.selectedFilterType == "liveCricketScore" ||
			this.state.selectedFilterType == "cricketPointsTable" ||
			this.state.selectedFilterType == "ShortByte"
		) {
			input["type"] = "storyType"
			input["storyType"] = this.state.selectedFilterType
		} else {
			input["type"] = "contentType"
			input["contentType"] = this.state.selectedFilterType
		}
		console.log(input, "input firstt========")
		const typeBasedContents = await SearchContentsByTypeAndCategory(input)
		console.log(typeBasedContents, "typeBasedContents=====")

		if (typeBasedContents.nextToken == null) {
			this.setState({
				publishedContentsList: [
					...this.state.publishedContentsList,
					...typeBasedContents.items,
				],
				nextToken: null,
			})
		} else {
			this.setState({
				publishedContentsList: [
					...this.state.publishedContentsList,
					...typeBasedContents.items,
				],
				nextToken: typeBasedContents.nextToken,
			})
		}
	};
	filterContentsByType = async () => {
		const input = {
			limit: 20,
			nextToken: null,
		}
		if (
			this.state.selectedFilterType == "liveCricketScore" ||
			this.state.selectedFilterType == "cricketPointsTable" ||
			this.state.selectedFilterType == "ShortByte"
		) {
			input["type"] = "storyType"
			input["storyType"] = this.state.selectedFilterType
		} else {
			input["type"] = "contentType"
			input["contentType"] = this.state.selectedFilterType
		}
		console.log(input, "input firstt========")
		const typeBasedContents = await SearchContentsByTypeAndCategory(input)
		console.log(typeBasedContents, "typeBasedContents=====")
		this.setState({
			nextToken: typeBasedContents.nextToken,
			publishedContentsList: typeBasedContents.items,
		})
	};
	selectContentType = (item) => {
		this.setState({ selectedFilterType: item }, () => {
			this.filterContentsByType()
		})
	};
	openCapturePostModal = (item) => {
		this.setState({
			selectedItem: item,
			capturePostModal: true,
			displayDescription: "",
		})
	};
	openTweetPostModal = (item) => {
		this.setState({
			selectedItem: item,
			tweetPostModal: true,
			tweetTitle: this.getContenttitle(item),
			tweetDescription: this.getContentDescription(item),
			tweetTags: this.getHashtags(item),
			twitterShareLink: this.getTwitterShareLink(item),
		})
	};

	closeTweetPostModal = () => {
		this.setState({ selectedItem: null, tweetPostModal: false })
	};
	closeCapturePostModal = () => {
		this.setState({ selectedItem: null, capturePostModal: false })
	};
	openDeleteModal = (item) => {
		this.setState({ selectedContentId: item, deleteModalVisible: true })
	};
	closeDeleteModal = (item) => {
		this.setState({ selectedContentId: "", deleteModalVisible: false })
	};
	openArchiveModal = (item) => {
		this.setState({ selectedContentId: item, archiveModalVisible: true })
	};
	closeArchiveModal = (item) => {
		this.setState({ selectedContentId: "", archiveModalVisible: false })
	};
	openAddToBoxOfficeModal = (item) => {
		this.setState({
			selectedContentId: item,
			addToBoxOfficeModalVisible: true,
		})
	};
	closeAddToBoxOfficeModal = (item) => {
		this.setState({ selectedContentId: "", addToBoxOfficeModalVisible: false })
	};

	handleDelete = async () => {
		const item = this.state.selectedContentId
		this.setState({ deleteModalVisible: false })

		if (
			this.state.selectedContentId.contentLanguages.length == 1 ||
			this.state.selectedContentId.contentLanguages.length ==
			this.state.selectedContentLanguages.length
		) {
			const input = { contentID: item.PK }
			console.log(input, "input")
			const data = await DeleteContent(input)
			console.log(data, "delete contenttttt")

			if (data.statusCode == "A185") {
				const refreshContentsList = this.state.publishedContentsList.filter(
					(data) => {
						return data.PK != item.PK
					}
				)

				this.setState({ publishedContentsList: refreshContentsList })
				toast.success("Content Deleted Successfully", this.toastStyle)
			} else {
				toast.error("Failed to delete content", this.toastStyle)
			}
		} else {
			const input = {
				contentID: item.PK,
				language: this.state.selectedContentLanguages[0],
			}
			const data = await DeleteContentInSingleLanguage(input)

			if (data.statusCode == "A296") {
				const index = this.state.publishedContentsList.findIndex(
					(data) => data.PK == item.PK
				)
				let deletedLang
				if (this.state.selectedContentLanguages[0] == "English") {
					deletedLang = "En"
				} else {
					deletedLang = "Te"
				}
				let selectedIdContentLangs = this.state.publishedContentsList[index]
					.contentLanguages
				selectedIdContentLangs = selectedIdContentLangs.filter(
					(lang) => lang !== deletedLang
				)

				this.state.publishedContentsList[
					index
				].contentLanguages = selectedIdContentLangs
				this.setState({
					publishedContentsList: this.state.publishedContentsList,
				})
				toast.success("Content Deleted Successfully", this.toastStyle)
			} else {
				toast.error("Failed to delete content", this.toastStyle)
			}
		}
	};
	handleArchive = async () => {
		const item = this.state.selectedContentId
		this.setState({ archiveModalVisible: false })
		let loggedInUserHandle = ""
		const loggedInUserEmail = Auth.user.attributes
			? Auth.user.attributes.email
			: ""
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split("@")
			loggedInUserHandle = "@" + emailParams[0]
		}
		const input = {
			contentID: item.PK,
			ModeratorID: Auth.user.username,
			moderatorHandle: loggedInUserHandle,
			appInfoFrontEnd: {
				UUID: Auth.user.username,
				appVersionNumber: 65,
			},
		}
		console.log(input, "inputtttt")
		const data = await ArchiveContentFromRedis(input)
		console.log(data, "dataaaaa")
		if (data.statusCode == "A243") {
			toast.success("Content Archived Successfully", this.toastStyle)
			const index = this.state.publishedContentsList.findIndex(
				(data) => data.PK == item.PK
			)
			this.state.publishedContentsList[index].archivedFromRedis = true
			this.setState({
				publishedContentsList: this.state.publishedContentsList,
			})
		} else {
			toast.error("Failed to archive content", this.toastStyle)
		}
	};
	displayToast = (type, message) => {
		if (type == "success") {
			toast.success(message, this.toastStyle)
		} else {
			toast.error(message, this.toastStyle)
		}
	};
	updateContentPoints = (contentID, points) => {
		const index = this.state.publishedContentsList.findIndex(
			(data) => data.PK == contentID
		)
		this.state.publishedContentsList[index].points =
			this.state.publishedContentsList[index].points + points
		this.setState({ publishedContentsList: this.state.publishedContentsList })
	};
	replaceContentPoints = (contentID, points) => {
		const index = this.state.publishedContentsList.findIndex(
			(data) => data.PK == contentID
		)
		this.state.publishedContentsList[index].points = points
		this.setState({ publishedContentsList: this.state.publishedContentsList })
	};
	handleAddToBoxOffice = async () => {
		const item = this.state.selectedContentId
		this.setState({ addToBoxOfficeModalVisible: false })
		let loggedInUserHandle = ""
		const loggedInUserEmail = Auth.user.attributes
			? Auth.user.attributes.email
			: ""
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split("@")
			loggedInUserHandle = "@" + emailParams[0]
		}
		const input = {
			contentID: item.PK,
			ModeratorID: Auth.user.username,
			moderatorHandle: loggedInUserHandle,
			appInfoFrontEnd: {
				UUID: Auth.user.username,
				appVersionNumber: 65,
			},
		}
		console.log(input, "inputtttt")
		const data = await AddContentToBoxOffice(input)
		console.log(data, "dataaaaa")
		if (data.statusCode == "A295") {
			toast.success(
				"Content Added To Box office Successfully",
				this.toastStyle
			)
			const index = this.state.publishedContentsList.findIndex(
				(data) => data.PK == item.PK
			)
			this.state.publishedContentsList[index].archivedFromRedis = false
			this.setState({
				publishedContentsList: this.state.publishedContentsList,
			})
		} else {
			toast.error("Failed to add content to box office", this.toastStyle)
		}
	};

	handleLanguage = (selectedlang) => {
		const { selectedContentLanguages } = this.state
		const selectedLangIndex = selectedContentLanguages.findIndex(
			(lang) => lang == selectedlang
		)

		if (selectedContentLanguages.includes(selectedlang)) {
			selectedContentLanguages.splice(selectedLangIndex, 1)
		} else {
			selectedContentLanguages.push(selectedlang)
		}
		this.setState({ selectedContentLanguages: selectedContentLanguages })
	};
	changeAppLanguage = async (e) => {
		const { appLanguage } = this.state
		console.log(e, "eeeeeeeeeee")
		console.log(e.target.value, "e.target.value")
		const language = e.target.value
		if (language && appLanguage != language) {
			this.setState({ appLanguage: language }, async () => {
				console.log("in getPublishedContentsList")
				await this.getPublishedContentsList()
			})
			localStorage.setItem("appLanguage", language)
		}
	};
	componentDidMount = async () => {
		let appLanguage = localStorage.getItem("appLanguage")
		console.log(appLanguage, "appLanguage")
		appLanguage = appLanguage ? appLanguage : "Telugu"
		this.setState({ appLanguage: appLanguage }, async () => {
			await this.getPublishedContentsList()
		})
	};
	renderDeleteConfirmationModal = () => {
		const { deleteModalVisible, selectedContentLanguages } = this.state
		return (
			<Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
				<Modal.Body>
					<div>
						{this.state.selectedContentId.contentLanguages &&
							this.state.selectedContentId.contentLanguages.length > 1 &&
							this.state.selectedContentId.contentLanguages.map((language) => {
								let lang
								if (language == "En") {
									lang = "English"
								} else {
									lang = "Telugu"
								}
								return (
									<div class="row">
										<div class="col-md-1">
											<input
												type="checkbox"
												onClick={() => this.handleLanguage(lang)}
												checked={selectedContentLanguages.includes(lang)}
											></input>
										</div>
										<div class="col-md-8">
											<text for="text"> {lang} </text>
										</div>
									</div>
								)
							})}
					</div>
					<div className="row">
						<text>Are you sure you want to delete this content?</text>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeDeleteModal()}>Cancel</Button>
					{this.state.selectedContentId.contentLanguages &&
						this.state.selectedContentId.contentLanguages.length > 1 ? (
						this.state.selectedContentLanguages.length > 0 ? (
							<Button onClick={() => this.handleDelete()}>Ok</Button>
						) : (
							<Button disabled onClick={() => this.handleDelete()}>
								Ok
							</Button>
						)
					) : (
						<Button onClick={() => this.handleDelete()}>Ok</Button>
					)}
				</Modal.Footer>
			</Modal>
		)
	};

	PrintDiv = (storyTitle) => {
		html2canvas(document.getElementById("sharecard"), {
			useCORS: true,
		}).then(function (canvas) {
			var imageURL = canvas.toDataURL("image/png")
			let a = document.createElement("a")
			a.href = imageURL
			a.download = storyTitle
			a.click()
		})
	};

	getHashtags = (selectedItem) => {
		console.log(selectedItem, "selectedItem")
		const hashTag1 = selectedItem.creatorVideoHashTag1
		const hashtag2 = selectedItem.creatorVideoHashTag2
		const hashTag3 = selectedItem.creatorVideoHashTag3
		const hashTag4 = selectedItem.creatorVideoHashTag4
		const hashTags = [hashTag1, hashtag2, hashTag3, hashTag4]
		let availableHashTags = []
		hashTags.map((item) => {
			if (item) availableHashTags.push(item)
		})
		return availableHashTags.join(" ")
	};

	getTwitterShareLink = (selectedItem) => {
		const { wordPressPostStatus, wordPressPostURL } =
			selectedItem?.wordPressInfo || ""
		if (wordPressPostStatus == "publish" && wordPressPostURL) {
			return wordPressPostURL
		}
		return this.defaultTwitterShareLink
	};

	renderCapturePostModal = () => {
		const { selectedItem, displayDescription } = this.state
		if (selectedItem) {
			let lang = "En"
			if (selectedItem.contentLanguages) {
				lang = selectedItem.contentLanguages.includes("En") ? "En" : "Te"
			}
			const { storyDetails } = selectedItem?.contentMetaInfo
			const storyTitle = storyDetails[`storyTitle_${lang}`]
			const storyCardDescription = storyDetails[`storyCardDescription_${lang}`]
			const displayDescriptionVal =
				displayDescription == "" ? storyCardDescription : displayDescription
			return (
				<Modal show={this.state.capturePostModal}>
					<Modal.Body>
						<div
							className="row"
							style={{ alignItems: "center", justifyContent: "center" }}
						>
							<div
								style={{
									marginTop: heightPercentageToDP("1"),
									marginBottom: heightPercentageToDP("1"),
									textAlign: "center",
								}}
							>
								<text style={{ textAlign: "center", fontWeight: "bold" }}>
									Download Image
								</text>
							</div>
							<div class="row" style={{ marginTop: 5, marginBottom: 5 }}>
								<text style={{ fontWeight: "bold" }}>Description :</text>
								<textarea
									type="text"
									onChange={(e) => {
										this.setState({ displayDescription: e.target.value })
									}}
									value={displayDescriptionVal}
								></textarea>
							</div>
							<text style={{ fontWeight: "bold" }}>Image Thumbnail :</text>
							<div
								style={{
									width: widthPercentageToDP("100%"),
									height: widthPercentageToDP("100%"),
									backgroundColor: "black",
									padding: 0,
								}}
								id="sharecard"
							>
								<div
									style={{
										marginTop: heightPercentageToDP("1%"),
										marginBottom: heightPercentageToDP("1%"),
										textAlign: "center",
									}}
								>
									<text
										style={{
											color: "yellow",
											fontFamily: fonts.fontFamilyPoppinsLight,
											fontWeight: "bold",
											textAlign: "center",
											fontSize: heightPercentageToDP("1.8%"),
										}}
									>
										{storyTitle}
									</text>
								</div>
								<div
									style={{
										overflow: "hidden",
										height: widthPercentageToDP("65%"),
									}}
								>
									<img
										style={{
											width: widthPercentageToDP("100%"),
										}}
										src={selectedItem ? this.getContentUri(selectedItem) : ""}
									/>
								</div>
								<div
									style={{
										marginTop: heightPercentageToDP("0.5%"),
										marginBottom: heightPercentageToDP("0.5%"),
										paddingLeft: widthPercentageToDP("1%"),
										paddingRight: widthPercentageToDP("1%"),
									}}
								>
									<MDEditor.Markdown
										className="sharecontentEllipsesStyle"
										style={{
											color: "white",
											textAlign: "center",
											fontSize: heightPercentageToDP("1.6%"),
											overflow: "hidden",
										}}
										source={displayDescriptionVal}
									/>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closeCapturePostModal()}>Cancel</Button>
						<Button onClick={() => this.PrintDiv(storyTitle)}>
							DownLoad Image
						</Button>
					</Modal.Footer>
				</Modal>
			)
		} else {
			return null
		}
	};

	postTweet = async () => {
		const {
			twitterShareLink,
			twitterShareLinkText,
			tweetTitle,
			tweetDescription,
			tweetTags,
			enableTwitterShareLink,
			selectedItem,
			attachAppPromoteText,
		} = this.state
		const appPromoteText = attachAppPromoteText ? twitterShareLinkText : ""
		const addTweetShareLinkText = enableTwitterShareLink ? appPromoteText : ""
		const tweetTotalText =
			tweetDescription + `\n` + tweetTags + `\n` + addTweetShareLinkText
		let input = {}
		if (enableTwitterShareLink) {
			input = {
				title: tweetTotalText,
				link: twitterShareLink,
			}
		} else {
			input = {
				title: tweetTotalText,
				contentID: selectedItem.PK,
			}
		}
		console.log(input, "here is the input")
		const data = await CreateTwitterPost(input)
		if (data.statusCode == "A200") {
			toast.success("Title updated Successfully", this.toastStyle)
		} else {
			toast.error("Failed to Title update", this.toastStyle)
		}
		this.closeTweetPostModal()
	};

	renderTweetPostModal = () => {
		const {
			selectedItem,
			twitterShareLinkText,
			tweetTitle,
			tweetDescription,
			tweetTags,
			enableTwitterShareLink,
			attachAppPromoteText,
		} = this.state
		if (selectedItem) {
			const appPromoteText = attachAppPromoteText ? twitterShareLinkText : ""
			const addTweetShareLinkText = enableTwitterShareLink
				? appPromoteText
				: ""
			const tweetTotalText =
				tweetDescription + `\n` + tweetTags + `\n` + addTweetShareLinkText
			return (
				<Modal show={this.state.tweetPostModal} size="xl">
					<Modal.Body>
						<div class="row col-md-12">
							<div class="row col-md-6">
								<div>
									<div>
										<span>
											<input
												type="radio"
												onClick={() =>
													this.setState({
														enableTweetImages: true,
														enableTwitterShareLink: false,
														attachAppPromoteText: false,
													})
												}
												checked={this.state.enableTweetImages}
											></input>
											<text style={{ fontWeight: "bold" }}>Image</text>
										</span>
										<span>
											<input
												type="radio"
												onClick={() =>
													this.setState({
														enableTweetImages: false,
														enableTwitterShareLink: true,
													})
												}
												checked={this.state.enableTwitterShareLink}
											></input>
											<text style={{ fontWeight: "bold", marginLeft: 5 }}>
												Share Link
											</text>
										</span>
									</div>
									{this.state.enableTweetImages ? (
										<div
											style={{
												overflow: "hidden",
												height: widthPercentageToDP("65%"),
											}}
										>
											<img
												style={{
													width: widthPercentageToDP("100%"),
												}}
												src={
													selectedItem ? this.getContentUri(selectedItem) : ""
												}
											/>
										</div>
									) : null}

									<div style={{ marginTop: 5, marginBottom: 5 }}>
										{this.state.enableTwitterShareLink ? (
											<div>
												<div class="row">
													<text style={{ fontWeight: "bold" }}>
														Share Link:
													</text>
													<textarea
														type="text"
														onChange={(e) => {
															this.setState({
																twitterShareLink: e.target.value,
															})
														}}
														value={this.state.twitterShareLink}
													></textarea>
													<div class="col">
														<a
															href={this.state.twitterShareLink}
															target={"_blank"}
														>
															Preview URL Page
														</a>
														<text
															onClick={() =>
																this.setState({
																	twitterShareLink: this
																		.defaultTwitterShareLink,
																})
															}
															style={{
																marginLeft: widthPercentageToDP("8"),
																color: "blue",
																cursor: "pointer",
															}}
														>
															Reset Default share link
														</text>
													</div>
												</div>

												<div class="row">
													<div>
														<span>
															<input
																type="checkbox"
																value={this.state.attachAppPromoteText}
																onClick={() =>
																	this.setState({
																		attachAppPromoteText: !this.state
																			.attachAppPromoteText,
																	})
																}
															/>
															<text style={{ fontWeight: "bold" }}>
																App Promote Text:
															</text>
														</span>
													</div>
													{this.state.attachAppPromoteText ? (
														<textarea
															type="text"
															onChange={(e) => {
																this.setState({
																	twitterShareLinkText: e.target.value,
																})
															}}
															value={
																this.state.attachAppPromoteText
																	? this.state.twitterShareLinkText
																	: ""
															}
														></textarea>
													) : null}
												</div>
											</div>
										) : null}
										<div class="row">
											<text style={{ fontWeight: "bold" }}>HashTags :</text>
											<textarea
												type="text"
												onChange={(e) => {
													this.setState({ tweetTags: e.target.value })
												}}
												value={tweetTags}
												style={{ marginLeft: 10 }}
											></textarea>
										</div>

										<div class="row">
											<text style={{ fontWeight: "bold" }}>Description :</text>
											<textarea
												type="text"
												onChange={(e) => {
													this.setState({ tweetDescription: e.target.value })
												}}
												style={{
													marginLeft: 10,
													minHeight: heightPercentageToDP("26"),
												}}
												value={tweetDescription}
											></textarea>
										</div>
									</div>
								</div>
							</div>
							<div class="row col-md-1"></div>
							<div class="row col-md-5" style={{ alignItems: "flex-start" }}>
								<div class="row">
									<text style={{ fontWeight: "bold", marginBottom: 10 }}>
										Tweet Post Preview:
									</text>
									{this.state.enableTweetImages ? (
										<text>*Images Attached</text>
									) : (
										<text>*Link Attached</text>
									)}
									<textarea
										readOnly
										type="text"
										onChange={() => null}
										style={{
											marginLeft: 10,
											minHeight: heightPercentageToDP("36"),
										}}
										value={tweetTotalText}
									></textarea>
									<text style={{ fontWeight: "bold" }}>
										Count: {tweetTotalText?.length}/256
									</text>
								</div>
								{tweetTotalText?.length > 256 && (
									<text style={{ color: "red" }}>
										Maximum allowed characteres in Twitter post is 256
									</text>
								)}
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closeTweetPostModal()}>Cancel</Button>
						<Button
							onClick={() => this.postTweet()}
							disabled={tweetTotalText?.length > 256 ? true : false}
						>
							Post Tweet
						</Button>
					</Modal.Footer>
				</Modal>
			)
		} else {
			return null
		}
	};

	renderArchiveConfirmationModal = () => {
		const { archiveModalVisible } = this.state
		return (
			<Modal show={archiveModalVisible} onHide={() => this.closeArchiveModal()}>
				<Modal.Body>
					<div className="row">
						<text>Are you sure you want to archive this content?</text>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeArchiveModal()}>Cancel</Button>
					<Button onClick={() => this.handleArchive()}>Ok</Button>
				</Modal.Footer>
			</Modal>
		)
	};
	renderAddToBoxOfficeConfirmationModal = () => {
		const { addToBoxOfficeModalVisible } = this.state
		return (
			<Modal
				show={addToBoxOfficeModalVisible}
				onHide={() => this.closeAddToBoxOfficeModal()}
			>
				<Modal.Body>
					<div className="row">
						<text>Are you sure you want to add this content to boxoffice?</text>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeAddToBoxOfficeModal()}>
						Cancel
					</Button>
					<Button onClick={() => this.handleAddToBoxOffice()}>Ok</Button>
				</Modal.Footer>
			</Modal>
		)
	};

	displayFilter = (item) => {
		const { displayContents } = this.state
		const contentType =
			item.storyType && item.storyType != ""
				? item.storyType
				: item.contentType

		return displayContents.includes(contentType)
	};

	renderTable = (heading, contentList) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{heading.map((head) => (
							<th style={{ fontSize: "14px", verticalAlign: "middle" }}>
								{head}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{contentList &&
						contentList.map(
							(row, index) =>
								this.displayFilter(row) && this.renderTableRow(row, index)
						)}
				</tbody>
			</Table>
		)
	};
	getContenttitle = (item) => {
		let thumbnailTitle = ""

		const {
			storyDetails,
			coverStoryDetails,
			mcqDetails,
			slideShowDetails,
			pollDetails,
			liveCricketDetails,
			cricketPointsTableDetails,
			liveNewsSectionDetails,
		} = item.contentMetaInfo
		const content = item
		let lang = "En"
		if (item.contentLanguages) {
			lang = item.contentLanguages.includes("En") ? "En" : "Te"
		}
		const contentType =
			item.storyType && item.storyType != ""
				? item.storyType
				: item.contentType

		switch (contentType) {
			case "Story":
			case "ShortByte":
				thumbnailTitle = storyDetails && storyDetails[`storyTitle_${lang}`]
				break
			case "Mcq":
				thumbnailTitle = mcqDetails && mcqDetails[`mcqTitle_${lang}`]
				break
			case "Poll":
				thumbnailTitle = pollDetails && pollDetails[`pollTitle_${lang}`]
				break
			case "liveCricketScore":
				thumbnailTitle =
					liveCricketDetails && liveCricketDetails[`liveCricketTitle_${lang}`]
				break
			case "cricketPointsTable":
				thumbnailTitle =
					cricketPointsTableDetails &&
					cricketPointsTableDetails[`cricketPointsTableTitle_${lang}`]
				break
			case "CoverStory":
				const {
					flipToStoryDetails,
					onlyCoverDetails,
					inAppBrowserDetails,
				} = coverStoryDetails
				switch (coverStoryDetails.coverStoryType) {
					case "FlipToStory":
						thumbnailTitle =
							flipToStoryDetails &&
							flipToStoryDetails[`coverStoryTitle_${lang}`]
						break
					case "OnlyCover":
						thumbnailTitle =
							onlyCoverDetails && onlyCoverDetails[`coverStoryTitle_${lang}`]
						break
					case "InAppBrowser":
						thumbnailTitle =
							inAppBrowserDetails &&
							inAppBrowserDetails[`coverStoryTitle_${lang}`]
						break
					default:
						thumbnailTitle = ""
				}
				break
			case "SlideShow":
				thumbnailTitle =
					slideShowDetails && slideShowDetails[`slideShowTitle_${lang}`]
				break
			case "liveNews":
				thumbnailTitle = liveNewsSectionDetails
					? liveNewsSectionDetails.length > 0
						? liveNewsSectionDetails[0][`liveNewsTitle_${lang}`]
						: ""
					: ""
				break
			default:
				thumbnailTitle = ""
		}
		return thumbnailTitle
	};
	getContentDescription = (item) => {
		let thumbnailTitle = ""

		const {
			storyDetails,
			coverStoryDetails,
			mcqDetails,
			slideShowDetails,
			pollDetails,
			liveCricketDetails,
			cricketPointsTableDetails,
			liveNewsSectionDetails,
		} = item.contentMetaInfo
		const content = item
		let lang = "En"
		if (item.contentLanguages) {
			lang = item.contentLanguages.includes("En") ? "En" : "Te"
		}
		const contentType =
			item.storyType && item.storyType != ""
				? item.storyType
				: item.contentType

		switch (contentType) {
			case "Story":
			case "ShortByte":
				thumbnailTitle =
					storyDetails && storyDetails[`storyCardDescription_${lang}`]
				break
			case "Mcq":
				thumbnailTitle =
					mcqDetails && mcqDetails[`explanationCardTitle_${lang}`]
				break
			case "Poll":
				thumbnailTitle = pollDetails && pollDetails[`pollDescription_${lang}`]
				break
			case "liveCricketScore":
				thumbnailTitle =
					liveCricketDetails &&
					liveCricketDetails[`liveCricketDescription_${lang}`]
				break
			case "cricketPointsTable":
				thumbnailTitle =
					cricketPointsTableDetails &&
					cricketPointsTableDetails[`cricketPointsTableDescription_${lang}`]
				break
			case "CoverStory":
				const {
					flipToStoryDetails,
					onlyCoverDetails,
					inAppBrowserDetails,
				} = coverStoryDetails
				switch (coverStoryDetails.coverStoryType) {
					case "FlipToStory":
						thumbnailTitle =
							flipToStoryDetails &&
							flipToStoryDetails[`coverStoryCardDescription_${lang}`]
						break
					case "OnlyCover":
						thumbnailTitle =
							onlyCoverDetails &&
							onlyCoverDetails[`coverStoryCardDescription_${lang}`]
						break
					case "InAppBrowser":
						thumbnailTitle =
							inAppBrowserDetails &&
							inAppBrowserDetails[`coverStoryCardDescription_${lang}`]
						break
					default:
						thumbnailTitle = ""
				}
				break
			case "SlideShow":
				thumbnailTitle = ""
				break
			case "liveNews":
				thumbnailTitle = liveNewsSectionDetails
					? liveNewsSectionDetails.length > 0
						? liveNewsSectionDetails[0][`liveNewsDescription_${lang}`]
						: ""
					: ""
				break
			default:
				thumbnailTitle = ""
		}
		return thumbnailTitle
	};
	getContentUri = (item) => {
		let uri
		const {
			storyDetails,
			coverStoryDetails,
			mcqDetails,
			pollDetails,
			slideShowDetails,
			thumbnailURL,
			liveCricketDetails,
			cricketPointsTableDetails,
			liveNewsSectionDetails,
		} = item.contentMetaInfo
		const cdnurl = AwsConfig.cdn_url
		const contentType =
			item.storyType && item.storyType != ""
				? item.storyType
				: item.contentType

		switch (contentType) {
			case "Story":
			case "ShortByte":
				uri =
					storyDetails &&
					storyDetails.storyCardImages &&
					storyDetails.storyCardImages[0] &&
					storyDetails.storyCardImages[0].image
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}
				if (uri == undefined && storyDetails && storyDetails.youtubeID != "") {
					uri = `https://img.youtube.com/vi/${storyDetails.youtubeID}/default.jpg`
				}
				if (!uri && thumbnailURL) {
					uri = thumbnailURL
					if (uri && !uri.includes(cdnurl)) {
						uri = cdnurl + thumbnailURL
					}
				}
				break
			case "Mcq":
				uri =
					mcqDetails &&
					mcqDetails.mcqImages &&
					mcqDetails.mcqImages[0] &&
					mcqDetails.mcqImages[0].image
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}
				break
			case "Poll":
				uri =
					pollDetails &&
					pollDetails.pollImage &&
					pollDetails.pollImage[0] &&
					pollDetails.pollImage[0].image
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}
				break
			case "CoverStory":
				const {
					flipToStoryDetails,
					onlyCoverDetails,
					inAppBrowserDetails,
				} = coverStoryDetails
				switch (coverStoryDetails.coverStoryType) {
					case "FlipToStory":
						uri =
							flipToStoryDetails &&
							flipToStoryDetails.coverStoryImages &&
							flipToStoryDetails.coverStoryImages[0] &&
							flipToStoryDetails.coverStoryImages[0].image
						if (uri && !uri.includes(cdnurl)) {
							uri = cdnurl + uri
						}
						if (
							uri == undefined &&
							flipToStoryDetails &&
							flipToStoryDetails.youtubeID != ""
						) {
							uri = `https://img.youtube.com/vi/${flipToStoryDetails.youtubeID}/default.jpg`
						}
						if (!uri && thumbnailURL) {
							uri = thumbnailURL
							if (uri && !uri.includes(cdnurl)) {
								uri = cdnurl + thumbnailURL
							}
						}
						break
					case "OnlyCover":
						uri =
							onlyCoverDetails &&
							onlyCoverDetails.coverStoryImages &&
							onlyCoverDetails.coverStoryImages[0] &&
							onlyCoverDetails.coverStoryImages[0].image
						if (uri && !uri.includes(cdnurl)) {
							uri = cdnurl + uri
						}
						if (
							uri == undefined &&
							onlyCoverDetails &&
							onlyCoverDetails.youtubeID != ""
						) {
							uri = `https://img.youtube.com/vi/${onlyCoverDetails.youtubeID}/default.jpg`
						}
						if (!uri && thumbnailURL) {
							uri = thumbnailURL
							if (uri && !uri.includes(cdnurl)) {
								uri = cdnurl + thumbnailURL
							}
						}
						break
					case "InAppBrowser":
						uri =
							inAppBrowserDetails &&
							inAppBrowserDetails.coverStoryImages &&
							inAppBrowserDetails.coverStoryImages[0] &&
							inAppBrowserDetails.coverStoryImages[0].image
						if (uri && !uri.includes(cdnurl)) {
							uri = cdnurl + uri
						}
						break
					default:
						uri = ""
				}
				break
			case "SlideShow":
				uri = slideShowDetails && slideShowDetails.slideShowImage
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}
				break
			case "liveCricketScore":
				uri =
					liveCricketDetails &&
					liveCricketDetails.liveCricketImages &&
					liveCricketDetails.liveCricketImages[0] &&
					liveCricketDetails.liveCricketImages[0].image
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}

				break
			case "cricketPointsTable":
				uri =
					cricketPointsTableDetails &&
					cricketPointsTableDetails.cricketPointsTableImages &&
					cricketPointsTableDetails.cricketPointsTableImages[0] &&
					cricketPointsTableDetails.cricketPointsTableImages[0].image
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}
				break
			case "liveNews":
				// uri = "";
				if (liveNewsSectionDetails) {
					uri =
						liveNewsSectionDetails.length > 0
							? liveNewsSectionDetails[0].liveNewsImages &&
							liveNewsSectionDetails[0].liveNewsImages[0] &&
							liveNewsSectionDetails[0].liveNewsImages[0].image
							: ""
					uri = uri && uri != "" && uri.includes(cdnurl) ? uri : cdnurl + uri
					if (uri == undefined && liveNewsSectionDetails[0].youtubeID != "") {
						uri = `https://img.youtube.com/vi/${liveNewsSectionDetails[0].youtubeID}/default.jpg`
					}
					if (!uri && thumbnailURL) {
						uri = thumbnailURL
						if (uri && !uri.includes(cdnurl)) {
							uri = cdnurl + thumbnailURL
						}
					}
				} else {
					uri = ""
				}
				break
			default:
				uri = ""
		}
		let image = uri

		console.log(typeof (cdnurl), 'type of cdn urllll==========')
		let removedcdnurl = ''
		if (image.includes(cdnurl)) {
			removedcdnurl = image.replaceAll(cdnurl, '')
			console.log(removedcdnurl, "abcabc")
		}
		image = cdnurl + removedcdnurl
		return image
	};
	getTeamBUri = (item) => {
		let uri
		const { liveCricketDetails } = item.contentMetaInfo
		const cdnurl = AwsConfig.cdn_url
		const contentType =
			item.storyType && item.storyType != ""
				? item.storyType
				: item.contentType

		switch (contentType) {
			case "liveCricketScore":
				uri =
					liveCricketDetails &&
					liveCricketDetails.liveCricketImages &&
					liveCricketDetails.liveCricketImages[1] &&
					liveCricketDetails.liveCricketImages[1].image
				if (uri && !uri.includes(cdnurl)) {
					uri = cdnurl + uri
				}
				break

			default:
				uri = ""
		}
		return uri
	};
	renderTitle = (item) => {
		let title = ""
		if (item.contentType == "Story" || item.contentType == "ShortByte") {
			title = item.contentMetaInfo.storyDetails.storyTitle
		} else if (item.contentType == "CoverStory") {
			const coverStoryType =
				item.contentMetaInfo.coverStoryDetails.coverStoryType
			if (coverStoryType == "FlipToStory") {
				title =
					item.contentMetaInfo.coverStoryDetails.flipToStoryDetails
						.coverStoryTitle
			} else if (coverStoryType == "OnlyCover") {
				title =
					item.contentMetaInfo.coverStoryDetails.onlyCoverDetails
						.coverStoryTitle
			} else if (coverStoryType == "InAppBrowser") {
				title =
					item.contentMetaInfo.coverStoryDetails.inAppBrowserDetails
						.coverStoryTitle
			}
			// title = item.contentMetaInfo.storyDetails.storyTitle
		} else if (item.contentType == "Mcq") {
			title = item.contentMetaInfo.mcqDetails.mcqTitle
		} else if (item.contentType == "SlideShow") {
			title = item.contentMetaInfo.slideShowDetails.slideShowTitle
		}
		return <text>{title}</text>
	};
	renderDescription = (item) => {
		let description = ""
		if (item.contentType == "Story" || item.contentType == "ShortByte") {
			description = item.contentMetaInfo.storyDetails.storyCardDescription
		}
		if (item.contentType == "CoverStory") {
			const coverStoryType =
				item.contentMetaInfo.coverStoryDetails.coverStoryType
			if (coverStoryType == "FlipToStory") {
				description =
					item.contentMetaInfo.coverStoryDetails.flipToStoryDetails
						.coverStoryCardDescription
			} else if (coverStoryType == "OnlyCover") {
				description =
					item.contentMetaInfo.coverStoryDetails.onlyCoverDetails
						.coverStoryCardDescription
			}
		} else if (item.contentType == "Mcq") {
			description = item.contentMetaInfo.mcqDetails.explanationCardTitle
		}
		return <text>{description}</text>
	};
	getFormattedDate = (date) => {
		var dd = date.getDate()
		var mm = date.getMonth() + 1

		var yyyy = date.getFullYear()
		if (dd < 10) {
			dd = "0" + dd
		}
		if (mm < 10) {
			mm = "0" + mm
		}
		var formattedDate = dd + "/" + mm + "/" + yyyy
		var hh = date.getHours()
		var m = date.getMinutes()
		var d = "AM"
		var h = hh
		if (h >= 12) {
			h = hh - 12
			d = "PM"
		}
		if (h == 0) {
			h = 12
		}
		m = m < 10 ? "0" + m : m
		const formattedTime = h + ":" + m + " " + d
		return formattedDate + " " + formattedTime
	};
	getPublishedDate = (time) => {
		const pubDate = new Date(time * 1000)
		const PublishedDate = this.getFormattedDate(pubDate)
		return PublishedDate
	};
	handleSelect = (dates) => {
		const start = new Date(dates.selection.startDate)
		start.setHours(0, 0, 0, 0)
		const end = new Date(dates.selection.endDate)
		end.setHours(23, 59, 59, 999)

		const dateObj = {
			startDate: start,
			endDate: end,
			key: "selection",
		}

		this.setState({
			selectionRange: dateObj,
			showDatePicker: false,
			filtered: true,
		})
	};
	openDatePicker = () => {
		this.setState({ showDatePicker: true })
	};
	filterData = async () => {
		const { selectionRange, limit } = this.state
		const epochStartTime = selectionRange.startDate.getTime()
		const epochEndTime = selectionRange.endDate.getTime()
		const startTime = Math.trunc(epochStartTime / 1000)
		const endTime = Math.trunc(epochEndTime / 1000)
		const input = {
			limit: limit,
			nextToken: null,
			fromTime: startTime,
			toTime: endTime,
			contentStatus: "published",
			appInfoFrontEnd: {
				appVersionNumber: 60,
			},
			language: this.state.appLanguage,
		}
		const publishedContentsList = await GetContentsList(input)

		this.setState({
			nextToken: publishedContentsList.nextToken,
			publishedContentsList: publishedContentsList.items,
			selectedFilterType: "",
		})
	};
	clearSearch = () => {
		this.setState({
			searchQuery: "",
			from: 0,
			searched: false,
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: "selection",
			},
			selectedFilterType: "",
		})
		this.getPublishedContentsList()
	};
	getSearchContents = async (type) => {
		this.setState({ render: false })
		const input = {
			currentLoggedInUserID: Auth.user.username,
			search: this.state.searchQuery,
			from: parseInt(this.state.initialFromValue),
			limit: 100,
			nextToken: null,
			appInfoFrontEnd: {
				appVersionNumber: 60,
				UUID: Auth.user.username,
			},
		}
		console.log(input, "input firstt========")
		const searchResult = await SearchContentsService(input)
		console.log(searchResult, "searchResult=====")

		this.setState({
			publishedContentsList: searchResult.items ? searchResult.items : [],
			render: true,
			searched: true,
			totalSearchResultsCount: searchResult.total,
			filteredContentTypes: searchResult.filteredContentTypes,
			filteredContentMainCategories: searchResult.filteredContentMainCategories,
			filteredFirstLevelContentCategories:
				searchResult.filteredFirstLevelContentCategories,
			filteredSecondLevelContentCategories:
				searchResult.filteredSecondLevelContentCategories,
			filteredThirdLevelContentCategories:
				searchResult.filteredThirdLevelContentCategories,
		})
	};
	getNextSearchContents = async (type) => {
		const input = {
			currentLoggedInUserID: Auth.user.username,
			search: this.state.searchQuery,
			from: this.state.initialLoadMore
				? parseInt(this.state.from) + this.state.limit
				: this.state.from,
			limit: 100,
			nextToken: null,
			appInfoFrontEnd: {
				appVersionNumber: 60,
				UUID: Auth.user.username,
			},
		}
		console.log(input, "input firstt========")
		const searchResult = await SearchContentsService(input)
		console.log(searchResult, "searchResult=====")

		this.setState({
			initialLoadMore: false,
			publishedContentsList: searchResult.items
				? [...this.state.publishedContentsList, ...searchResult.items]
				: [],
			from: this.state.initialLoadMore
				? parseInt(this.state.from) +
				this.state.limit +
				parseInt(this.state.limit)
				: parseInt(this.state.from) + this.state.limit,
			searched: true,
			totalSearchResultsCount: searchResult.total,
			filteredContentTypes: searchResult.filteredContentTypes,
			filteredContentMainCategories: searchResult.filteredContentMainCategories,
			filteredFirstLevelContentCategories:
				searchResult.filteredFirstLevelContentCategories,
			filteredSecondLevelContentCategories:
				searchResult.filteredSecondLevelContentCategories,
			filteredThirdLevelContentCategories:
				searchResult.filteredThirdLevelContentCategories,
		})
	};
	onChangeSearch = (searchQuery) => {
		this.setState({ searchQuery: searchQuery })
	};
	search = () => {
		this.getSearchContents("search")
	};
	resetFilter = () => {
		this.setState({
			searchQuery: "",
			from: 0,
			searched: false,
			selectedFilterType: "",
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: "selection",
			},
		})
		this.getPublishedContentsList()
	};


	//-----------------  


	editpop = () => {
		if (this.pop === true) {
			this.setState({ pop: false })
		} else {
			this.setState({ pop: true })
		}
	};


	//------------






	handleEditTitle = (e, index) => {

		console.log(index, "edittitleindex")

		console.log(e.target.value, "newFirstnamenewFirstname")
		this.setState({ Title: e.target.value })
	}


	handlesavetitle = (e, index) => {


		// this.props.onUpdate(this.state);
		this.setState({ editedTitle: e.target.value, editpopup: false })
	}

	handlecanceltitlt = (index) => {
		console.log("cancel", index)
		this.setState({ editpopup: false })
	}
	//------------------------------
	handleEditDesc = (e, index) => {

		console.log(index, "editDescindex")

		console.log(e.target.value, "newFirstnamenewFirstname")
		this.setState({ Desc: e.target.value })
	}


	handlesaveDesc = (e, index) => {
		let { editedArray, Desc } = this.state
		let objvalues = {
			Desc,
			index
		}

		editedArray.push(objvalues)
		console.log(editedArray, "editedArrayafterpush")

		e.preventDefault()
		console.log("submit", index)
		console.log(this.state.editingIndex, 'editingIndex====')
		// this.props.onUpdate(this.state);
		this.setState({ editDescPopup: false })
	}

	handlecancelDesc = (index) => {
		console.log("cancel", index)
		this.setState({ editDescPopup: false })
	}
	renderTableRow = (item, index) => {
		const deletePublishedContents = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["deletePublishedContents"]
		)
		const archivePublishedContentsPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["archivePublishedContentsPermission"]
		)
		const checkAddToBoxOfficePermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["addOrRemoveFromBoxOfficePermission"]
		)
		const modifyPointsPublishedContentsPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["modifyPointsPublishedContentsPermission"]
		)
		const publishedContentsNewsOnTopPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["publishedContentsNewsOnTopPermission"]
		)
		const editPublishedContentsPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["editPublishedContentsPermission"]
		)
		const duplicateContentPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["duplicateContentPermission"]
		)
		const addContentToListPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["addContentToListPermission"]
		)
		const repostContentPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["repostContentPermission"]
		)

		const sendContentPushNotificationPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions["sendContentPushNotificationPermission"]
		)
		const editTitle = this.state.editpopup
		const currentTime = Math.trunc(new Date().getTime() / 1000)
		let title = this.getContenttitle(item)

		console.log(this.getContenttitle(item), "this.getContenttitle(item);")
		if (this.state.searched) {
			var start = title
				.toLowerCase()
				.indexOf(this.state.searchQuery.toLowerCase())
			var end = this.state.searchQuery.toLowerCase().slice().length
			var matchWord = title.substring(start, start + end)

			if (
				title.toLowerCase().match(this.state.searchQuery.toLowerCase()) ||
				title.match(this.state.searchQuery.toLowerCase())
			) {
				title = title.replace(
					matchWord,
					'<label class="highlight">' + matchWord + "</label>"
				)
			}
		}
		let description = this.getContentDescription(item)
		if (this.state.searched && description) {
			var descstart = description
				.toLowerCase()
				.indexOf(this.state.searchQuery.toLowerCase())
			var descend = this.state.searchQuery.toLowerCase().slice().length
			var descMatch = description.substring(descstart, descstart + descend)

			if (
				description.toLowerCase().match(this.state.searchQuery.toLowerCase())
			) {
				description = description.replace(
					descMatch,
					'<label class="highlight">' + descMatch + "</label>"
				)
			}
		}

		const PK = item.PK.replace("cont#", "")
		const checkDisplayRow = this.state.showArchived
			? true
			: !item.archivedFromRedis
		let lang = "En"
		if (item.contentLanguages) {
			lang = item.contentLanguages.includes("En") ? "En" : "Te"
		}
		let isStickyPost = false
		let isCampaign = false
		if (
			item.stickyPost != undefined &&
			item.stickyPost != null &&
			item.stickyPost
		) {
			isStickyPost = true
		} else if (
			item.isInAppMessage != undefined &&
			item.isInAppMessage != null &&
			item.isInAppMessage
		) {
			if (
				item.inAppMessageDetails != undefined &&
				item.inAppMessageDetails != null &&
				Object.keys(item.inAppMessageDetails).length > 0
			) {
				isCampaign = true
			}
		}
		const isContentInWordPress =
			item.wordPressInfo &&
				Object.keys(item.wordPressInfo).length > 0 &&
				item.wordPressInfo.wordPressID
				? true
				: false
		let wpPostURL = ""
		if (isContentInWordPress) {
			wpPostURL = item.wordPressInfo.wordPressPostURL
		}
		const contentType =
			item.storyType && item.storyType != ""
				? item.storyType
				: item.contentType

		// function HandleEditTitle() {


		//   this.setState({ editpopup: true })
		console.log("HandleEditTitle")
		// }
		// const handleInputChange = e => {
		//   this.setState({ Title: e.target.value });
		// };
		// const handleFormSubmit = e => {
		//   e.preventDefault();
		console.log("submit")
		//   // this.props.onUpdate(this.state);
		//   this.setState({ editpopup: false });
		// };

		// const onCancel = () => {
		//   this.setState({ editpopup: false });
		// };
		return checkDisplayRow ? (
			<tr>
				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
				>
					{index + 1}
				</td>
				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
				>
					<div
						class="row d-flex justify-content-center align-items-center"
						style={{ fontSize: "12px", minWidth: "120px" }}
					>
						{editPublishedContentsPermission ? (
							<Link
								data-toggle="tooltip"
								title={`Edit Content`}
								style={styles.fontSize}
								class="col-md-3 faIconClass"
								to={`/editContent?${PK}`}
								target="_blank"
							>
								<i class="fas fa-pencil-alt fa-lg" />
							</Link>
						) : null}
						{item.contentType == "Story" && duplicateContentPermission ? (
							<DuplicateContentForm
								item={item}
								displayToast={this.displayToast}
							/>
						) : null}
						<div
							class="col-md-3 faIconClass"
							data-toggle="tooltip"
							title={`Tweet`}
							style={styles.fontSize}
							onClick={() => {
								this.openTweetPostModal(item)
							}}
						>
							<i class="fab fa-twitter fa-lg" />
						</div>
						{item.contentType == "Story" && (
							<Link
								data-toggle="tooltip"
								title={`Share`}
								style={styles.fontSize}
								class="col-md-3 faIconClass"
								to={`/shareContent?${PK}`}
								target="_blank"
							>
								<i class="fas fa-share-alt fa-lg" />
							</Link>
							// <div
							//   data-toggle='tooltip'
							//   title={`Share`}
							//   style={styles.fontSize}
							//   class='col-md-3 faIconClass'
							//   onClick={() => {
							//     this.openCapturePostModal(item)
							//   }}
							// >
							//   <i class='fas fa-share-alt fa-lg' />
							// </div>
						)}
						{deletePublishedContents ? (
							<div
								data-toggle="tooltip"
								title={`Delete`}
								style={styles.fontSize}
								class="col-md-3 faIconClass"
								onClick={() => {
									this.openDeleteModal(item)
								}}
							>
								<i class="fas fa-trash fa-lg" />
							</div>
						) : null}

						{Auth.user.attributes &&
							!item.archivedFromRedis &&
							!isStickyPost &&
							!isCampaign &&
							Auth.user.attributes.email &&
							Auth.user.attributes.phone_number &&
							archivePublishedContentsPermission ? (
							<div
								data-toggle="tooltip"
								title={`Archive`}
								style={styles.fontSize}
								class="col-md-3 faIconClass"
								onClick={() => {
									this.openArchiveModal(item)
								}}
							>
								<i class="fas fa-archive fa-lg" />
							</div>
						) : null}
						{Auth.user.attributes &&
							item.archivedFromRedis &&
							!isStickyPost &&
							!isCampaign &&
							Auth.user.attributes.email &&
							Auth.user.attributes.phone_number &&
							checkAddToBoxOfficePermission ? (
							<div
								data-toggle="tooltip"
								title={`Add To BoxOffice`}
								style={styles.fontSize}
								class="col-md-3 faIconClass"
								onClick={() => {
									this.openAddToBoxOfficeModal(item)
								}}
							>
								<i class="fas fa-plus fa-lg" />
							</div>
						) : null}
						{Auth.user.attributes &&
							Auth.user.attributes.email &&
							Auth.user.attributes.phone_number &&
							modifyPointsPublishedContentsPermission &&
							item.contentMainCategory != "news" ? (
							<AddPointsToContent
								item={item}
								displayToast={this.displayToast}
								updateContentPoints={this.updateContentPoints}
								replaceContentPoints={this.replaceContentPoints}
							/>
						) : null}
						{Auth.user.attributes &&
							Auth.user.attributes.email &&
							Auth.user.attributes.phone_number &&
							publishedContentsNewsOnTopPermission &&
							!isStickyPost &&
							!isCampaign &&
							item.contentMainCategory == "news" &&
							!item.archivedFromRedis ? (
							<NewsOnTop
								item={item}
								displayToast={this.displayToast}
								updateContentPoints={this.updateContentPoints}
								replaceContentPoints={this.replaceContentPoints}
							/>
						) : null}
						{repostContentPermission ? (
							<RepostContentAction
								item={item}
								displayToast={this.displayToast}
								updateContentPoints={this.updateContentPoints}
								replaceContentPoints={this.replaceContentPoints}
							/>
						) : null}

						{addContentToListPermission ? (
							<AddContentToListAction
								item={item}
								displayToast={this.displayToast}
								updateContentPoints={this.updateContentPoints}
								replaceContentPoints={this.replaceContentPoints}
							/>
						) : null}

						{sendContentPushNotificationPermission ? (
							<SendPushNotification
								item={item}
								displayToast={this.displayToast}
							/>
						) : null}
					</div>
				</td>
				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
					style={{ fontSize: "12px", minWidth: "150px" }}
				>
					{item.contentCreatedDateTime
						? this.getPublishedDate(item.contentCreatedDateTime)
						: "-"}
				</td>
				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
					style={{ fontSize: "12px", minWidth: "150px" }}
				>
					{item.contentPublishedDateTime
						? this.getPublishedDate(item.contentPublishedDateTime)
						: "-"}
				</td>
				<td class="permalinkCellStyle" style={styles.fontSize}>
					{isContentInWordPress ? (
						<a href={wpPostURL} target="_blank">
							{wpPostURL}
						</a>
					) : (
						"-"
					)}
				</td>

				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
					style={styles.fontSize}
				>
					{contentType != "liveCricketScore" ? (
						<img style={{ height: "150px" }} src={this.getContentUri(item)} />
					) : null}
					{contentType == "liveCricketScore" ? (
						<div class="d-flex justify-content-evenly">
							<img
								height="150"
								style={{ borderRadius: 50 }}
								src={this.getContentUri(item)}
							/>
							<img
								height="150"
								style={{ borderRadius: 50 }}
								src={this.getTeamBUri(item)}
							/>
						</div>
					) : null}
				</td>
				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
					style={{ fontSize: "12px", minWidth: "300px" }}
				>
					<div style={{
						display: "flex",
						justifyContent: "spaceBetween",
						position: 'relative'
					}}>
						<div style={{ width: '16rem' }}><MDEditor.Markdown style={{ backgroundColor: 'inherit' }} source={title} /></div>

						<EditTitle status="published" getUnpublishedContentsList={this.getPublishedContentsList} item={item} title={title} publishedContentsListdata={this.state.publishedContentsListdata} index={index} />

					</div>
				</td>
				<td
					data-toggle="tooltip"
					title={`Points : ${item.points},\nLikes : ${item.likes},\nViews : ${item.viewed},\nShares : ${item.sharedVideoCount},\nComments :${item.commentsCount}`}
					style={{ fontSize: "12px", minWidth: "300px" }}
				>
					{description ? (
						<p style={{ width: '16rem', position: 'relative' }} className="text" st>
							{this.state.isReadMore ? (
								<div style={{ display: "flex" }}>
									<MDEditor.Markdown style={{ backgroundColor: 'inherit' }} source={description.slice(0, 150)} />
									<EditDesc style={{ backgroundColor: 'inherit' }} item={item} getUnpublishedContentsList={this.getPublishedContentsList} publishedContentsListdata={this.state.publishedContentsListdata} description={description} index={index} />
								</div>
							) : (
								<div style={{ display: "flex" }}>
									<MDEditor.Markdown style={{ backgroundColor: 'inherit' }} source={description} />
									<EditDesc style={{ backgroundColor: 'inherit' }} item={item} getUnpublishedContentsList={this.getPublishedContentsList} publishedContentsListdata={this.state.publishedContentsListdata} description={description} index={index} />

								</div>
							)}
							{description.length > 150 ? (
								<span style={{ cursor: 'pointer', display: "inline" }}
									onClick={() => {
										this.setState({ isReadMore: !this.state.isReadMore })
									}}
									className="read-or-hide"
								>
									<b>
										{this.state.isReadMore
											? <div style={{ cursor: 'pointer' }}>...Read more ▼</div>
											: <div style={{ cursor: 'pointer' }}>...Read less ▲</div>}
									</b>
								</span>
							) : null}
						</p>
					) : null}
					<div style={{ display: "inline" }}>
					</div>
					{/* <button style={{ height: "25px", width: "25px" }} onClick={() => {
            this.setState({ editDescPopup: true, editingIndexDesc: index });
            console.log("hiiidesc", index)
          }}>
            <i class='fa fa-edit'></i>
          </button> */}
					{/* {this.state.editDescPopup && index==this.state.editingIndexDesc ? (

<Modal show={this.editpop} fullscreen={"md-down"} onHide={() => this.setState({pop:false})}>
<Modal.Header >
  <Modal.Title>Edit Description</Modal.Title>
</Modal.Header>
<Modal.Body>
            <div class="main">
              <form id="formInput" style={{  padding: "20px" }} onSubmit={this.handleFormSubmit}>
                <textarea
                  id="firstname"
                  value={this.props.Title}
                  type="firstname"
                  name="firstname"
                  placeholder="Firstname"
                  onChange={(e) => this.handleEditDesc(e, index)}
                  required
                />
                <div>
                  <button class=" m-1 btn btn-primary" type="submit" value="Submit" onClick={(e) => this.handlesaveDesc(e, index)
                  }>

                    Save
                  </button>
                  <button class="btn btn-primary" type="reset" value="Reset" onClick={() => this.handlecancelDesc(index)}>

                    Cancel
                  </button>
                </div>
              </form>
            </div>
            </Modal.Body>
              </Modal>

          ) : null} */}
				</td>
				<td style={{ minWidth: '150px', fontSize: '12px' }}>
					{item.originalCreatorName ? item.originalCreatorName : '-'}
				</td>
				<td style={{ minWidth: '150px', fontSize: '12px' }}>
					{item.originalCreatorHandle ? item.originalCreatorHandle : '-'}
				</td>

				<td style={styles.fontSize}>
					{item.contentType == 'Poll'
						? item.contentMetaInfo.pollDetails.pollInfo.map((option, index) => {
							const polledPercentage = item.polledCount
								? Math.round(
									(option.votes /
										(item.polledCount ? item.polledCount : 0)) *
									100,
								)
								: 0
							return (
								<text>
									{option[`choice_${lang}`]}
									{'-'}
									{`${polledPercentage}%`}
									{'\n'}
								</text>
							)
						})
						: '-'}
				</td>
				<td style={styles.fontSize}>
					{item.polledCount ? item.polledCount : '-'}
				</td>
				<td style={styles.fontSize}>{item.points}</td>
				<td style={styles.fontSize}>{item.likes}</td>

				<td style={styles.fontSize}>{item.viewed}</td>

				<td style={styles.fontSize}>{item.sharedVideoCount}</td>

				<td style={styles.fontSize}>{item.commentsCount}</td>
				<td style={styles.fontSize}>{item.createdFrom}</td>

				<td style={styles.fontSize}>{item.isScheduled ? 'True' : 'False'}</td>
				<td style={{ fontSize: '12px', minWidth: '150px' }}>
					{item.isScheduled && item.scheduledTime
						? this.getPublishedDate(item.scheduledTime)
						: '-'}
				</td>

				<td style={{ fontSize: '12px', minWidth: '300px' }}>{item.PK}</td>
				<td style={styles.fontSize}>
					{item.contentType == 'CoverStory'
						? item.contentMetaInfo && item.contentMetaInfo.coverStoryDetails
							? item.contentMetaInfo.coverStoryDetails.coverStoryType
							: item.contentType
						: item.storyType && item.storyType != ''
							? item.storyType
							: item.contentType}
				</td>

				<td style={styles.fontSize}>{item.contentMainCategory}</td>

				<td style={styles.fontSize}>
					{item.archivedFromRedis ? 'True' : 'False'}
				</td>
				<td style={styles.fontSize}>
					{item.contentLanguages ? item.contentLanguages.join(',') : '-'}
				</td>
				<td style={styles.fontSize}>
					{item.approvedContentLanguages
						? item.approvedContentLanguages.join(',')
						: '-'}
				</td>
				<td style={styles.fontSize}>
					{item.targetAreasV2 ? item.targetAreasV2.join(',') : '-'}
				</td>
			</tr>
		) : null
	}

	render() {
		const {
			publishedContentsList,
			headings,
			selectionRange,
			showDatePicker,
			loading,
		} = this.state
		return (
			<section className='feed'>
				{/* {this.state.editpopup ? (

<Modal show={this.state.editpopup} fullscreen={"md-down"} onHide={() => this.setState({pop:false})}>
<Modal.Header >
  <Modal.Title>Edit Title</Modal.Title>
</Modal.Header>
<Modal.Body>
<div class="main">
    <input
      id="firstname"
      value={this.state.Title}
      type="firstname"
      name="firstname"
      placeholder="Firstname"
      onChange={(e) => this.handleEditTitle(e, this.state.editingIndex)}
      required
    />
    <div>
      <button class=" m-1 btn btn-primary" type="button"  onClick={(e) => this.handlesavetitle(e, this.state.editingIndex)
      }>

        Save
      </button>
      <button class="btn btn-primary" type="button" value="button" onClick={() => this.handlecanceltitlt(this.state.editingIndex)}>

        Cancel
      </button>

    </div>
</div>
</Modal.Body>
</Modal>
) : null} */}
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				{loading ? <Spinner /> : null}
				<Header
					changeAppLanguage={this.changeAppLanguage}
					appLanguage={this.state.appLanguage}
				/>

				<div>
					<label>Published Contents</label>
				</div>

				{this.state.searched ? (
					<div>
						<div className='row'>
							<div className='col-md-2'>
								<label>Content Types </label>
								{this.state.filteredContentTypes &&
									this.state.filteredContentTypes.map((item, index) => (
										<div>
											{item.key}-{item.doc_count}
										</div>
									))}
							</div>
							<div className='col-md-2'>
								<label>Content Main Categories </label>

								{this.state.filteredContentMainCategories
									? this.state.filteredContentMainCategories.map(
										(item, index) => (
											<div>
												{item.key}-{item.doc_count}
											</div>
										),
									)
									: null}
							</div>
							<div className='col-md-2'>
								<label>First Level Categories </label>

								{this.state.filteredFirstLevelContentCategories
									? this.state.filteredFirstLevelContentCategories.map(
										(item, index) => (
											<div>
												{item.key}-{item.doc_count}
											</div>
										),
									)
									: null}
							</div>
							<div className='col-md-2'>
								<label>Second Level Categories </label>

								{this.state.filteredSecondLevelContentCategories
									? this.state.filteredSecondLevelContentCategories.map(
										(item, index) => (
											<div>
												{item.key}-{item.doc_count}
											</div>
										),
									)
									: null}
							</div>
							<div className='col-md-2'>
								<label>Third Level Categories </label>

								{this.state.filteredThirdLevelContentCategories
									? this.state.filteredThirdLevelContentCategories.map(
										(item, index) => (
											<div>
												{item.key}-{item.doc_count}
											</div>
										),
									)
									: null}
							</div>
						</div>
					</div>
				) : null}
				<div>
					<input
						type='text'
						onChange={e => {
							this.onChangeSearch(e.target.value)
						}}
						value={this.state.searchQuery}
						placeholder='Search Contents'
					></input>
					<Button
						disabled={!this.state.searchQuery}
						style={{ marginRight: 10 }}
						onClick={() => {
							this.search()
						}}
					>
						Search
					</Button>
					<Button
						disabled={!this.state.searchQuery}
						style={{ marginRight: 10 }}
						onClick={() => {
							this.clearSearch()
						}}
					>
						Clear
					</Button>
				</div>
				{this.state.publishedContentsList &&
					this.state.publishedContentsList.length > 0 ? (
					<div>
						<div className='row'>
							<div className='col-md-4'>
								<text>Start Date : </text>
								<input
									type='text'
									onClick={() => {
										this.openDatePicker()
									}}
									value={this.getFormattedDate(selectionRange.startDate)}
									placeholder='Choose Start Date'
								></input>
							</div>

							<div className='col-md-4'>
								<text>End Date : </text>
								<input
									type='text'
									onClick={() => {
										this.openDatePicker()
									}}
									value={this.getFormattedDate(selectionRange.endDate)}
									placeholder='Choose End Date'
								></input>
							</div>
							<div className='col-md-4'>
								<Button
									style={{ marginRight: 10 }}
									onClick={() => {
										this.filterData()
									}}
								>
									Filter By Date Time
								</Button>
							</div>
						</div>
						<div>
							{showDatePicker ? (
								<DateRangePicker
									ranges={[selectionRange]}
									onChange={this.handleSelect}
								/>
							) : null}
						</div>
						<div>
							<label>Filter list based on ContentType </label>
							<div>
								{this.state.contentsTypes.map(item => (
									<div>
										<input
											type='radio'
											onClick={() => {
												this.selectContentType(item)
											}}
											checked={this.state.selectedFilterType == item}
										></input>
										<text>{item}</text>
									</div>
								))}
							</div>
						</div>
						<div>
							<label>Show Archived Contents</label>
							<div>
								<div>
									<input
										type='checkbox'
										onClick={this.toggleShowArchived}
										checked={this.state.showArchived}
									></input>
									<text>{'Show Archived'}</text>
								</div>
							</div>
						</div>
						<Button
							onClick={() => {
								this.resetFilter()
							}}
						>
							Reset Filters
						</Button>
						<div style={{ marginTop: 10 }}>
							{this.renderTable(headings, publishedContentsList)}
						</div>
					</div>
				) : (
					<div>
						<label>Filter list based on ContentType </label>
						<div>
							{this.state.contentsTypes.map(item => (
								<div>
									<input
										type='radio'
										onClick={() => {
											this.selectContentType(item)
										}}
										checked={this.state.selectedFilterType == item}
									></input>
									<text>{item}</text>
								</div>
							))}
						</div>
						<div>No Data To Display</div>
					</div>
				)}

				{this.renderDeleteConfirmationModal()}
				{this.renderArchiveConfirmationModal()}
				{this.renderAddToBoxOfficeConfirmationModal()}
				{this.renderCapturePostModal()}
				{this.renderTweetPostModal()}

				{!this.state.selectedFilterType &&
					this.state.publishedContentsList &&
					this.state.publishedContentsList.length > 0 &&
					this.state.render &&
					this.state.nextToken != null &&
					!this.state.searchQuery && (
						<button onClick={this.loadMore} type='button' className='load-more'>
							Load more
						</button>
					)}

				{this.state.selectedFilterType &&
					this.state.nextToken != null &&
					!this.state.searchQuery && (
						<button
							onClick={this.loadMoreContentsByType}
							type='button'
							className='load-more'
						>
							Load more
						</button>
					)}
				{this.state.publishedContentsList &&
					this.state.publishedContentsList.length > 0 &&
					this.state.render &&
					this.state.searchQuery &&
					this.state.publishedContentsList.length <
					this.state.totalSearchResultsCount && (
						<button
							onClick={() => this.getNextSearchContents()}
							type='button'
							className='load-more'
						>
							Load more Results
						</button>
					)}
			</section>
		)
	}
}

export default PublishedContentsList
